export default "__VITE_ASSET__lhgG4yCa__"